export default __webpack_public_path__ + "static/media/grimcorruptor.0e903a6f.png";